import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import axios from 'axios';
import {
  Card,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Snackbar,
  SnackbarContent,
  IconButton,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import { MdClose } from 'react-icons/lib/md';
import get from 'lodash/get';

import blockProps from '../../utils/blockProps';
import Loader from '../../components/Loader';
import FormBuilder from '../../components/FormBuilder';

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayForm: false,
      dataLoaded: false,
      data: null,
      error: null,
      agree: false,
      snackbarOpened: false,
      snackbarMessage: '',
      formError: false,
      formErrorMessages: {},
      submittingForm: false,
      language: 'english',
    };
  }

  fetchRegistrationForm = async () => {
    this.setState({ dataLoaded: false });
    try {
      const {
        data: { data },
      } = await axios.options(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/registrations/?language=${
          this.state.language
        }`,
      );

      this.setState({ dataLoaded: true, data });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpened: false,
      snackbarMessage: '',
      formError: false,
    });
  };

  clearFormErrorForField = (field) => {
    this.setState(state => ({
      formErrorMessages: _.omit(state.formErrorMessages, [field]),
    }));
  };

  submitForm = async (formData) => {
    this.setState({ submittingForm: true });
    try {
      const { data } = await axios.post(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/registrations/?language=${
          this.state.language
        }`,
        formData,
      );
      const response = data.data || {};

      this.setState(
        {
          submittingForm: false,
          snackbarOpened: true,
          snackbarMessage: response.message,
        },
        () => {
          setTimeout(() => {
            window.location = `/registration-quiz/${response.id}`;
          }, 2000);
        },
      );
    } catch (error) {
      const errorMessages = get(error, 'response.data.data.errors');
      this.setState({
        submittingForm: false,
        formError: true,
        formErrorMessages: errorMessages || {},
        snackbarOpened: true,
        snackbarMessage: 'please check for error in the form',
      });
    }
  };

  render() {
    if (!this.state.displayForm) {
      return (
        <CardsContainer>
          <StyledCard>
            <Typography variant="display1" color="primary" gutterBottom>
              JYP Registration 2018-2019
            </Typography>

            <Typography variant="title">Instructions</Typography>

            <ul>
              <li>
                <Typography variant="subheading">Last Date for Registration.</Typography>
                <Table>
                  <TableData>
                    <Typography variant="body2">City</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body2">Last Date</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Aligarh</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">Allahabad</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Delhi</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Dehradun</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Gorakhpur</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Hisar</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">25th Dec 2018</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Kanpur</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Lucknow</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Meerut</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Patna</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Ranchi</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>

                  <TableData>
                    <Typography variant="body1">Varanasi</Typography>
                  </TableData>
                  <TableData>
                    <Typography variant="body1">closed</Typography>
                  </TableData>
                </Table>
              </li>
              <li>
                <Typography variant="subheading">Registration is a 2 steps process.</Typography>
                <ul>
                  <li>
                    <Typography variant="subheading">
                      Process I include the form submission.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="subheading">
                      Process II is a 10 minutes online entrance test.
                    </Typography>
                  </li>
                </ul>
              </li>
              <li>
                <Typography variant="subheading">
                  Do not close the window until the entrance test submission.
                </Typography>
              </li>
            </ul>

            <div>
              <Typography variant="title">Choose the Form language</Typography>
              <StyledRadioGroup
                aria-label="form-language"
                name="form-language"
                value={this.state.language}
                onChange={(event) => {
                  const { value } = event.target;
                  this.setState({ language: value }, this.fetchRegistrationForm);
                }}
              >
                <FormControlLabel
                  value="english"
                  control={<Radio color="primary" />}
                  label="English"
                />
                <FormControlLabel value="hindi" control={<Radio color="primary" />} label="Hindi" />
              </StyledRadioGroup>
            </div>

            <ActionContainer>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({ displayForm: true }, this.fetchRegistrationForm);
                }}
              >
                Register
              </Button>
            </ActionContainer>
          </StyledCard>
        </CardsContainer>
      );
    }

    if (!this.state.dataLoaded) {
      return <Loader />;
    }

    if (this.state.error) {
      return <Error>{this.state.error}</Error>;
    }

    return (
      <CardsContainer>
        <StyledCard>
          <Typography variant="display1" color="primary" gutterBottom>
            {this.state.data.title}
          </Typography>

          <FormBuilder
            errors={this.state.formErrorMessages}
            config={this.state.data}
            clearErrorForField={this.clearFormErrorForField}
            renderFormActions={({ validateForm, formData }) => (
              <div>
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={this.state.agree}
                      onChange={(event) => {
                        this.setState({
                          agree: event.target.checked,
                        });
                      }}
                    />
)}
                  label={(
                    <Typography variant="body2">
                      I, hereby declare that the information supplied above is true. I have never
                      been found guilty of any offence by any court anywhere. I accept the terms and
                      conditions of participation in youth parliament.
                    </Typography>
)}
                />

                <ButtonContainer>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (validateForm(formData)) {
                        this.submitForm(formData);
                      } else {
                        this.setState({
                          snackbarOpened: true,
                          snackbarMessage: 'please check for error in the form',
                          formError: true,
                        });
                      }
                    }}
                    disabled={!this.state.agree}
                  >
                    Submit
                  </Button>
                </ButtonContainer>
              </div>
            )}
          />
        </StyledCard>

        <Snackbar
          open={this.state.snackbarOpened}
          autoHideDuration={2000}
          onClose={this.handleSnackbarClose}
        >
          <StyledSnackbarContent
            formError={this.state.formError}
            message={this.state.snackbarMessage}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackbarClose}
              >
                <MdClose size={20} />
              </IconButton>,
            ]}
          />
        </Snackbar>

        {this.state.submittingForm && <Loader />}
      </CardsContainer>
    );
  }
}

export default RegistrationForm;

const Error = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const CardsContainer = styled.div`
  margin: 20px 0;

  & > * + * {
    margin-top: 30px !important;
  }
`;

const StyledCard = styled(Card)`
  width: 960px;
  max-width: 90%;
  margin: 0 auto;
  padding: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
`;

const StyledSnackbarContent = styled(blockProps(SnackbarContent, ['formError']))`
  background-color: ${props => (props.formError ? 'red' : 'green')} !important;
`;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex !important;
  align-items: center !important;
  flex-direction: row !important;
`;

const Table = styled.div`
  width: 400px;
  max-width: 90%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-left: 32px;
  margin-bottom: 8px;
`;

const TableData = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 4px;
  text-align: center;
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
`;



// WEBPACK FOOTER //
// ./src/pages/RegistrationForm/RegistrationForm.js